export default __webpack_public_path__ + "static/media/number5.8b05b4b2.svg";